import { HttpParams } from '@angular/common/http';
import { Filter } from '../../../../../models';
import { periodicidadeAnual, PeriodicidadeFilter } from '../../../../../shared';
import { representanteAtivo } from '../../situacao';

/** Propriedades do filtro dos KPIs dos representantes */
export interface RepresentanteKPIFilterProps {
    // Periodicidade
    periodicidade: PeriodicidadeFilter;

    // Representantes
    idsRepresentantes: number[];
    somenteRepresentantesAtivos: boolean;

    // Modalidades Comerciais
    modalidadesComerciaisRepresentantes: number[];

    // Atendentes
    idsAtendentes: number[];
    // Gerentes
    idsGerentes: number[];
}

/** Filtro dos KPIs dos representantes */
export class RepresentanteKPIFilter implements Filter, RepresentanteKPIFilterProps {
    // Periodicidade
    periodicidade: PeriodicidadeFilter;

    // Representantes
    idsRepresentantes: number[];
    somenteRepresentantesAtivos: boolean;
    // Modalidades Comerciais
    modalidadesComerciaisRepresentantes: number[] = [];
    // Atendentes
    idsAtendentes: number[] = [];
    // Gerentes
    idsGerentes: number[] = [];

    constructor(props: Partial<RepresentanteKPIFilterProps>) {
        if (props) {
            this.periodicidade = new PeriodicidadeFilter(props.periodicidade);
            this.idsRepresentantes = props.idsRepresentantes ?? [];
            this.somenteRepresentantesAtivos = props.somenteRepresentantesAtivos ?? true;
            this.modalidadesComerciaisRepresentantes = props.modalidadesComerciaisRepresentantes ?? [];
            this.idsAtendentes = props.idsAtendentes ?? [];
            this.idsGerentes = props.idsGerentes ?? [];
        } else {
            this.periodicidade = new PeriodicidadeFilter({
                periodicidade: periodicidadeAnual.id,
                data: new Date()
            });
        }
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Periodicidade
        params = this.periodicidade.createParams(params);

        // Representantes
        this.idsRepresentantes?.forEach(idRepresentante => {
            params = params.append('idRepresentante', idRepresentante.toString());
        });
        // Situações representantes
        if (this.somenteRepresentantesAtivos) {
            params = params.append('situacaoRepresentante', representanteAtivo.id.toString());
        }

        // Modalidades Comerciais
        this.modalidadesComerciaisRepresentantes?.forEach(modalidadeComercialRepresentante => params = params.append('modalidadeComercialRepresentante', modalidadeComercialRepresentante.toString()));

        // Atendentes
        this.idsAtendentes?.forEach(idAtendente => {
            params = params.append('idsAtendentes', idAtendente.toString());
        });

        // Gerentes
        this.idsGerentes?.forEach(idGerente => {
            params = params.append('idsGerentes', idGerente.toString());
        });

        return params;
    }

    clear() {
        this.idsRepresentantes = [];
        this.somenteRepresentantesAtivos = true;

        // Modalidades Comerciais
        this.modalidadesComerciaisRepresentantes = [];

        this.idsAtendentes = [];
        this.idsGerentes = [];
    }
}
